import axios from 'axios';
import SESSION from '../apiUrls';
import getLastBuildTimestamp from '@/common-utils/functions/getLastBuildTimestamp';
import getLastBuildVersions from '@/common-utils/functions/getLastBuildVersions';

/**
 * @param responseData response.data object
 * @param responseData.lastBuildTimestamp string
 * @param responseData.lastBuildVersions string
 *
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};
    data.lastBuildTimestamp = getLastBuildTimestamp(response);
    data.lastBuildVersions = getLastBuildVersions(response);
    return data;
}

const queryGetLastBuildData = (enabled = true) => {
    return {
        queryKey: [SESSION.INDEX_HTML.queryKey],
        queryFn: async () => {
            const response = await axios.get(`${SESSION.INDEX_HTML.url}?_t=${Date.now()}`);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetLastBuildData;